export default __webpack_public_path__ + "static/media/girlPressingPhone.e525c256.jpg";